export enum sftpModifiedAtColumnSource {
  source = 'source',
  fileName = 'fileName',
}
